export default __webpack_public_path__ + "static/media/IMG_0937.2650492d.jpg";